import { DynamicFormRequiredType, type DynamicFormSettings } from '@myosh/odin-components';
import i18next from '../../../../i18n';
import type { FormBuilderField } from '../../../../redux/slices/form-builder-slice';

export const labelFieldFormSettings: DynamicFormSettings = {
  id: 'LabelFieldSettingsGroup',
  caption: '',
  fields: [
    {
      id: 'fieldData',
      fieldType: 'CUSTOM',
      customFieldType: 'RICHTEXTAREA',
      fieldName: 'fieldData',
      caption: i18next.t('additional-display-data'),
      required: DynamicFormRequiredType.False,
      permissions: { edit: true, read: true },
      dynamicProperties: {
        rows: 10,
      },
      position: 40,
    },
  ],
};

export const getLabelFieldValues = (field: FormBuilderField) => {
  const value = field.fieldData?.translations?.[0].value || '';
  return {
    fieldData: value,
  };
};
